module.exports = __webpack_public_path__ + "static/media/adserver_section4_mobile.ea86d3e3.png";